<template>
  <main class="doctors-register-content pt-2">
    <div
      :class="{ 'b-container': !isMobile }"
    >
      <h1
        class="text--text mb-sm-6 mb-4"
        :class="isMobile ? 'text-h6 px-2' : 'text-h5'"
      >
        {{ t('Регистрация врача', options) }}
      </h1>

      <div
        class="d-flex flex-column gr-md-16 gr-sm-12 gr-8 doctors-register-content__content"
        :class="{ 'px-2': isMobile }"
      >
        <RegistrationForm
          v-if="context.subject"
          :class="{ 'elevation-1 rounded-sm pa-12': !isMobile }"
          :is-doctor="context.is_doctor"
          :is-lpu="context.is_lpu"
          :date-of-sending-email="context.busy"
          :user-email="context.usr?.user?.email"
          :phone-confirmation-on-doctor-register="context.site_settings.phone_confirmation_on_doctor_register"
          :subject="context.subject"
        />
        <HowToRegister
          v-else
          :class="{ 'elevation-1 rounded-sm pa-12': !isMobile }"
        />

        <v-divider v-if="isMobile" />
        <BenefitsOfRegistration :class="{ 'elevation-1 rounded-sm pa-12': !isMobile }" />

        <v-divider v-if="isMobile" />
        <AdvantagesOfSite />
      </div>
    </div>

    <template v-if="context.doctor_rates && context.request.country.is_russia">
      <v-divider
        v-if="isMobile"
        class="mt-md-16 mt-sm-12 mt-8"
      />
      <DoctorRates class="mt-md-16 mt-sm-12 mt-8" />
    </template>
  </main>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'
import AdvantagesOfSite from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/AdvantagesOfSite.vue'
import BenefitsOfRegistration from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/BenefitsOfRegistration.vue'
import DoctorRates from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/DoctorRates/DoctorRates.vue'
import HowToRegister from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/HowToRegister.vue'
import RegistrationForm from 'src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/RegistrationForm.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
</script>

<style lang="scss" scoped>
.doctors-register-content {
  &__content > .v-divider {
    min-width: calc(100% + 16px);
    margin: 0 -8px;
  }
}
</style>
